import React from 'react';
import Spinner from 'react-spinkit';
import {connect} from 'react-redux';
import {getCompany} from "../../actions/companies";
import {Icon, Popover} from "antd";
import CompanyCard from "./CompanyCard";
import './CompanySmall.css';
import PropTypes from 'prop-types';

class CompanySmall extends React.Component {
  static defaultProps = {
    loading: false
  };

  componentDidMount() {
    const { onMount, loading, id } = this.props;
    if (id && loading && onMount) {
      onMount(id);
    }
  }

  render() {
    const { loading } = this.props;
    const { id, companyName, style } = this.props;
    if (!id) {
      return null;
    }
    if (loading) {
      return <Spinner className="companysmall-spinner" style={style} name='circle'/>
    }
    return (
      <span className='company-small' style={style}>
        <Popover content={<CompanyCard id={id}/>}>
          <span>
            <Icon type='idcard'/>
            {companyName}
          </span>
        </Popover>
      </span>
    );
  }
}

CompanySmall.propTypes = {
  id: PropTypes.string.isRequired
};

export default connect(
  (state, ownProps) => {
    let company = state.companies.data[ownProps.id];
    if (!company) { return { loading: true, id: ownProps.id}; }
    return {
      id: ownProps.id,
      companyName: company.resource.companyname
    };
  },
  (dispatch, ownProps) => ({
    onMount: (id) => dispatch(getCompany(id))
  })
)(CompanySmall);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CompanySmall.js